import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import heroBgImage from '../assets/KEMONITO.gif'; 
import { profileData } from '../data/profileData';
import '../styles/Home.css';

const Home = () => {
  const heroStyle = {
    backgroundImage: `url(${heroBgImage})`
  };

  return (
    <section className="hero-section d-flex align-items-center" style={heroStyle}>
      <Container>
        <Row className="align-items-center justify-content-center text-center">
          
          <Col lg={8} className="hero-content-wrapper">
            <h1 className="display-1 fw-bold mb-3 hero-title" data-aos="fade-up">
              Hello, I'm <br />
              <span className="text-highlight">{profileData.info.name.split(' ')[0]}</span>
            </h1>
            <p className="lead mb-4 fs-3 hero-subtitle" data-aos="fade-up" data-aos-delay="100">
              {profileData.info.role}
            </p>
            <div className="d-flex gap-3 justify-content-center" data-aos="fade-up" data-aos-delay="200">
              <a href="#projects" className="btn btn-primary btn-lg rounded-pill px-4 shadow-sm">
                See my projects
              </a>
              <a href="#contact" className="btn btn-outline-light btn-lg rounded-pill px-4">
                Contact me
              </a>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default Home;